import { ca } from '@cian/analytics';

import { type TApplyFiltersSource } from '@/packages/Filters/shared/types/applyFiltersSource';

interface ITrackApplyClickParameters {
  source: TApplyFiltersSource;
  queryString: string;
}

export function trackApplyClick({ source, queryString }: ITrackApplyClickParameters): void {
  const label = getLabel(queryString);

  switch (source) {
    case 'tooltip':
      trackTooltipSearchClick(label);
      break;
    case 'advancedFilters':
      trackAdvancedFiltersSearchClick(label);
      break;
    case 'findButton':
      trackSearchButtonClick(label);
      break;
  }
}

function trackTooltipSearchClick(label: string): void {
  ca('event', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'click_tooltip',
    label,
  });
}

function trackAdvancedFiltersSearchClick(label: string): void {
  ca('event', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'click_filters_block',
    label,
  });
}

function trackSearchButtonClick(label: string): void {
  ca('event', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'click',
    label,
  });
}

function getLabel(searchString: string): string {
  const searchStringRaw = searchString.split('?');

  return searchStringRaw.length > 1 ? searchStringRaw[1] : searchStringRaw[0];
}
